<template>
    <div class="interface-help">
        <h2>Электронная таблица</h2>
        <p>Данный интерфейс, имитирует работу с электронной таблицей. Он состоит из трех частей. Это:</p>
        <p>
            <b>Cтроку поиска</b>:<br>
            <img class="interface-help__image interface-help__image--1" src="/images/help/table-search.jpg" alt=""><br>
            Строка поиска, позволяет произвоить поиск информации в таблицы. Происходит поиск совподения текста из этого поля во всех ячейках таблицы. Если в строке таблицы нету совпадения с введенным текстом, строка скрывается. Таким образом, при поиске, отображается только информация имеющаяя совпадения.</p>
        <p>
            <b>Шапка таблицы</b>:<br>
            <img class="interface-help__image interface-help__image--2" src="/images/help/table-header.jpg" alt=""><br>
            Шапка таблицы, отображает название столбцов и позволяет производить сортировку. Если, при наведение на название столбца, курсор меняет свой внешний вид
            <img class="interface-help__image interface-help__image--4" src="/images/help/cursor_pointer.png" alt=""> , то для этого столбца доступна сортировка. Она произойдет при клике на заголовок столбца. При повторном клике, сортировка произойдет в обратном направлении. Название столбца, по которому произведена сортировка, будет выделено черным текстом и стрелкой, указывающей направление сортировки.
        </p>
        <p>
            <b>Список</b> - содержимое таблицы:<br>
            <img class="interface-help__image interface-help__image--3" src="/images/help/table-list.jpg" alt=""><br>
            В списке, отображается вся доступная в таблице информация. Часть информации может быть скрыта, если был произведен поиск.
        </p>
        <p>
            Общий вид электронной таблицы<br>
            <img class="interface-help__image" src="/images/help/table.jpg" alt="">
        </p>
    </div>
</template>
<script>
    export default {}
</script>
<style lang="stylus" scoped>
    .interface-help {
        p {
            max-width 80%
        }

        &__image {
            max-width 60%
            border 1px solid rgba(0, 0, 0, .4)

            &--1 {
                width 481px
            }

            &--2 {
                width 401px
            }

            &--3 {
                width 583px
            }

            &--4 {
                width 26px
                vertical-align middle
            }
        }
    }
</style>